import React, { useState } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

const ImgLoader = ({
  src,
  Classnames,
  styles = {},
  loaderstyles = {},
  loaderClassnames,
  loaderContainerClass,
  loaderContainerStyle = {}
}) => {
  const [isLoaded, setIsLoaded] = useState();
  return (
    <div className="">
      <div
        className={loaderContainerClass}
        style={{ ...loaderContainerStyle, display: isLoaded && 'none' }}
      >
        <CircularProgress
          className={`block mx-auto ${loaderClassnames}`}
          size={40}
          style={{ ...loaderstyles }}
          thickness={4}
        />
      </div>
      <img
        className={Classnames}
        style={{ ...styles, display: !isLoaded && 'none' }}
        src={src}
        onLoad={() => {
          setIsLoaded(true);
        }}
      />
    </div>
  );
};

export default ImgLoader;
